export default __webpack_public_path__ + "static/media/image.imi-games.0d672d13.png";